import { onDocumentLoaded } from "./helpers/utils"
import truncate from "./helpers/truncate"

const carouselClasses = [
  "voyage__carousel--prev",
  "voyage__carousel--active",
  "voyage__carousel--next",
]

export function voyageCarouselHandler() {
  // using spread operator to make the collection iterable
  const carousels = document.querySelectorAll(
    "body:not(.sfPageEditor) [data-carousel-items]"
  )

  Array.prototype.slice.call(carousels).forEach((carousel) => {
    const getPrevChild = (index) => getChildren()[index - 1]
    const getNextChild = (index) => getChildren()[index + 1]

    const removeClassesFromAllItems = () => {
      Array.prototype.slice
        .call(getChildren())
        .forEach((child) => child.classList.remove(...carouselClasses))
    }

    const setClasses = (activeItem /* index */) => {
      getChildren()[activeItem].classList.add("voyage__carousel--active")
      if (getPrevChild(activeItem))
        getPrevChild(activeItem).classList.add("voyage__carousel--prev")
      if (getNextChild(activeItem))
        getNextChild(activeItem).classList.add("voyage__carousel--next")
    }

    const setItem = (number, item) => {
      removeClassesFromAllItems()
      setClasses(number)
      var mediaId = item && item.dataset.mediaid ? item.dataset.mediaid : ""
      if (mediaId) {
        var id = mediaId.replace("carousel_", "media_")
        var mediaElement = document.getElementById(id)
        if (mediaElement) {
          var container = mediaElement.closest(".move-next")
          if (container) {
            Array.from(container.querySelectorAll('*[id^="media_"]')).forEach(
              function (media) {
                media.classList.add("voyage__hidden")
              }
            )
          }
          mediaElement.classList.remove("voyage__hidden")
        }

        var id = mediaId.replace("carousel_", "spinner_")
        var spinnerElement = document.getElementById(id)
        if (spinnerElement) {
          var container = spinnerElement.closest(".loading-spinner")
          if (container) {
            Array.from(
              container.querySelectorAll(".carousel-spinners")
            ).forEach(function (spinner) {
              spinner.classList.remove("active")
            })
          }
          spinnerElement.classList.add("active")
        }
      }
    }

    const getChildren = () => {
      return carousel.querySelectorAll(".voyage__carousel--item-wrapper")
    }

    const setInfityNext = () => {
      if (!isLastItem()) return
      const children = getChildren()
      for (var i = 0; i < children.length; i++) {
        var clone = children[i].cloneNode(true)
        clone.classList.remove("voyage__carousel--active")
        clone.classList.remove("voyage__carousel--prev")
        clone.classList.remove("voyage__carousel--next")
        addEventHandldersToclone(clone)
        carousel.append(clone)
      }
    }

    const addEventHandldersToclone = (clone) => {
      var link = clone.querySelector("a")
      if (!link) return
      if (window.openAccordionPopup === undefined) return
      link.addEventListener("click", function (e) {
        openAccordionPopup(e, false)
      })

      var image = clone.querySelector(
        ".voyage__highlighted-content--image > div"
      )
      if (!image) return
      if (window.openAccordionPopup === undefined) return
      image.addEventListener("click", function (e) {
        openAccordionPopup(e, true)
      })

      bindClickActions(
        carousel,
        "[data-carousel-prev]",
        voyageCarouselSlidePrev
      )
      bindClickActions(
        carousel,
        "[data-carousel-next]",
        voyageCarouselSlideNext
      )
    }

    const setInfityPrevious = (currentItem) => {
      if (!isFirstItem()) return currentItem
      const children = getChildren()
      for (var i = children.length - 1; i >= 0; i--) {
        var clone = children[i].cloneNode(true)
        clone.classList.remove("voyage__carousel--active")
        clone.classList.remove("voyage__carousel--prev")
        clone.classList.remove("voyage__carousel--next")
        addEventHandldersToclone(clone)
        carousel.prepend(clone)
      }
      return children.length
    }

    ;(function initializeClasses() {
      setItem(0)
      setClasses(0)
    })()

    const getCurrentItem = () =>
      Array.prototype.slice
        .call(getChildren())
        .findIndex((child) =>
          child.classList.contains("voyage__carousel--active")
        )
    const isLastItem = () =>
      Array.prototype.slice
        .call(getChildren())
        .findIndex((child) =>
          child.classList.contains("voyage__carousel--next")
        ) ===
      getChildren().length - 1
    const isFirstItem = () =>
      Array.prototype.slice
        .call(getChildren())
        .findIndex((child) =>
          child.classList.contains("voyage__carousel--active")
        ) === 0

    function voyageCarouselSlideNext() {
      const currentItem = getCurrentItem()
      setInfityNext()
      var next = getNextChild(currentItem)
      if (next) setItem(currentItem + 1, next)
      else setItem(0)
      calculateAccordionHeight(next)
    }

    function voyageCarouselSlidePrev() {
      var currentItem = getCurrentItem()
      currentItem = setInfityPrevious(currentItem)
      var previous = getPrevChild(currentItem)
      if (previous) setItem(currentItem - 1, previous)
      else setItem(Array.prototype.slice.call(getChildren()).length - 1)
      calculateAccordionHeight(previous)
    }

    function calculateAccordionHeight(element) {
      const expandable = element.closest(
        "#voyage__expandable, [data-id='voyage__expandable']"
      )
      if (!expandable) return
      const contentHeight = expandable.querySelector(
        "#voyage__expandable--content-wrapper, [data-id='voyage__expandable--content-wrapper']"
      ).clientHeight
      const content = expandable.querySelector(
        "#voyage__expandable--content, [data-id='voyage__expandable--content']"
      )
      content.style.height = contentHeight + 40 + "px"
    }

    /* <Touch and Click events section> */
    let touchStartX = null
    let touchStartY = null

    function onTouchStart(event) {
      const touchStart = event.touches[0] || event.changedTouches[0]
      touchStartX = touchStart.pageX
      touchStartY = touchStart.pageY
    }

    function onTouchEnd(event) {
      const touchEnd = event.touches[0] || event.changedTouches[0]
      const validateSwipeY =
        touchStartY - touchEnd.pageY < 50 && touchStartY - touchEnd.pageY > -50
      const swipeLeft = touchStartX - touchEnd.pageX > 15
      const swipeRight = touchStartX - touchEnd.pageX < -15

      if (swipeLeft && validateSwipeY) voyageCarouselSlideNext()
      if (swipeRight && validateSwipeY) voyageCarouselSlidePrev()

      touchStartX = null
      touchStartY = null
    }

    function bindClickActions(carousel, selector, functionName) {
      const buttons = carousel.parentElement.querySelectorAll(selector)
      Array.from(buttons).forEach(function (button) {
        button.addEventListener("click", functionName)
        if (getChildren().length < 2) {
          button.style.display = "none"
        }
      })
    }

    try {
      bindClickActions(
        carousel,
        "[data-carousel-prev]",
        voyageCarouselSlidePrev
      )
      bindClickActions(
        carousel,
        "[data-carousel-next]",
        voyageCarouselSlideNext
      )
    } catch {}

    try {
      carousel.addEventListener("touchstart", onTouchStart, { passive: true })
      carousel.addEventListener("touchend", onTouchEnd, { passive: true })
    } catch (err) {
      console.error(
        'carouselHandler: No element with data-attribute "[data-carousel-items]" found'
      )
    }
    /* </Touch and Click event section> */
  })

  const carouselsElements = document.querySelectorAll(".voyage__carousel")
  ;[].forEach.call(carouselsElements, (carouselsElement) => {
    const wrappers = document.querySelectorAll(
      ".voyage__carousel--item-wrapper"
    )
    ;[].forEach.call(wrappers, (wrapper) => {
      const contenTopText = wrapper.querySelector(
        ".voyage__highlighted-content--category"
      )
      const contentHeader = wrapper.querySelector(
        ".voyage__highlighted-content--topic"
      )
      const contentElement = wrapper.querySelector(
        ".voyage__highlighted-content--summary"
      )

      var contentHeaderText =
        contentHeader && contentHeader.innerText ? contentHeader.innerText : ""

      if (contentElement) {
        const textWithoutTruncate = wrapper.querySelector(
          ".text-without-truncate"
        )
        if (!textWithoutTruncate) {
          var truncatedCount =
            400 -
            predictTheContentTextLengthWhenLongHeaderText(contentHeaderText)
          truncatedCount =
            contenTopText && contenTopText.innerText
              ? truncatedCount
              : truncatedCount + 106
          contentElement.innerText = truncate(
            contentElement.innerText,
            truncatedCount
          )
        }
      }
    })
  })
}

const predictTheContentTextLengthWhenLongHeaderText = (contentHeaderText) => {
  // 27 is the max char length of the row
  if (contentHeaderText.length > 27 * 4) {
    return contentHeaderText.length * 2.2
  }

  if (contentHeaderText.length > 27 * 3) {
    return contentHeaderText.length * 2
  }

  if (contentHeaderText.length > 27 * 2) {
    return contentHeaderText.length * 1.8
  }

  if (contentHeaderText.length > 27) {
    return contentHeaderText.length * 1.6
  }

  return contentHeaderText.length
}

export default () => onDocumentLoaded(voyageCarouselHandler)
